import { render, staticRenderFns } from "./UploadNewForm.vue?vue&type=template&id=439a6d8f"
import script from "./UploadNewForm.vue?vue&type=script&lang=js"
export * from "./UploadNewForm.vue?vue&type=script&lang=js"
import style0 from "./UploadNewForm.vue?vue&type=style&index=0&id=439a6d8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports